import React from 'react';
import PropTypes from 'prop-types';
import LineScoreComp from '@mlb/react-patterns/components/LineScore/lineScore';
import Skeleton from '@mlb/react-patterns/components/Skeleton/skeleton';
import { LineScoreSkeleton, MainSkeletonSection, MiniSkeletonSection, GamedayLineScoreWrapper } from './LineScore.style';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';
const BoldComp = ({
    text
}) => {
    return <strong>{text}</strong>;
};

const FULLWIDE = 'fullwide';

const LineScore = ({
    awayAbbr,
    homeAbbr,
    awayTeamFull,
    homeTeamFull,
    totalsData,
    complete,
    winner,
    inningHalf,
    scheduledInnings,
    currentInning,
    innings,
    isLoading = false,
    useFullName = false
}) => {
    const translate = useTranslate();

    if (isLoading) {
        return (
            <LineScoreSkeleton>
                <MainSkeletonSection>
                    <Skeleton width='calc(100% - 80px)' height='15px' />
                    <Skeleton width='calc(100% - 20px)' height='20px' />
                    <Skeleton width='calc(100% - 20px)' height='20px' />
                </MainSkeletonSection>
                <MiniSkeletonSection>
                    <Skeleton width='70px' height='15px' />
                    <Skeleton width='70px' height='20px' />
                    <Skeleton width='70px' height='20px' />
                </MiniSkeletonSection>
            </LineScoreSkeleton>
        );
    }

    const headerAbbr = [
        <BoldComp text={translate('labelBrief_h_r', 'R')} />,
        <BoldComp text={translate('labelBrief_h_h', 'H')} />,
        <BoldComp text={translate('labelBrief_e"', 'E')} />
    ];

    return (
        <GamedayLineScoreWrapper>
            <LineScoreComp
                type='full'
                inningHalf={ inningHalf ? inningHalf.toLowerCase() : undefined }
                currentInning={ currentInning }
                scheduledInnings={ scheduledInnings }
                inningsData={ innings }
                awayName={useFullName ? awayTeamFull : awayAbbr}
                homeName={useFullName ? homeTeamFull : homeAbbr}
                totalsData={totalsData}
                complete={complete}
                winner={winner}
                headerAbbr={ headerAbbr }
            />
        </GamedayLineScoreWrapper>

    );
};

LineScore.propTypes = {
    awayAbbr: PropTypes.string,
    homeAbbr: PropTypes.string,
    awayTeamFull: PropTypes.string,
    homeTeamFull: PropTypes.string,
    totalsData: PropTypes.object,
    complete: PropTypes.bool,
    winner: PropTypes.oneOf(['away', 'home']),
    inningHalf: PropTypes.string,
    scheduledInnings: PropTypes.number,
    currentInning: PropTypes.number,
    innings: PropTypes.array,
    isLoading: PropTypes.bool,
    useFullName: PropTypes.bool
};

export default LineScore;
